import { useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logOutSuccess } from "../Reducer/authSlice";
import Storage from "../utils/HandelLocalStorage";


const INACTIVITY_LIMIT = 2 * 60 * 60 * 1000; // 2 hours in milliseconds
// const INACTIVITY_LIMIT = 5 * 60 * 1000; // 2 hours in milliseconds


export const UseInactivityLogout = () => {
  const navigate = useNavigate();
    const dispatch = useDispatch();
  
  let inactivityTimer;

    const logOut = () => {
      dispatch(logOutSuccess(null));
      Storage.clearItem("userDetails");
      Storage.clearItem("userOwnerDetails");
      Storage.clearItem("persist:root");
      Storage.clearItem("userHotelsDetails");
      Cookies.remove("authData");
      Cookies.remove("authHotelData");
  
      localStorage.removeItem("lng");
      // if (ownerPath?.includes(location?.pathname)) {
      //   navigate("/owner-login", { replace: true });
      // } else {
      navigate("/login", { replace: true });
      // }
    };

  const resetInactivityTimer = () => {
    clearTimeout(inactivityTimer);
    localStorage.setItem("lastActive", Date.now()); // Update last activity time
    inactivityTimer = setTimeout(() => {
        logOut();
    }, INACTIVITY_LIMIT); // 2 hours
  };

  useEffect(() => {

      // Check inactivity when user opens the app
      const lastActive = localStorage.getItem("lastActive");
      if (lastActive && (+Date.now() - +lastActive) > INACTIVITY_LIMIT) {
        logOut();
      } else {
    resetInactivityTimer(); // Start timer when the component mounts
      }
    // Attach event listeners
    window.addEventListener("mousemove", resetInactivityTimer);
    window.addEventListener("keydown", resetInactivityTimer);
    window.addEventListener("scroll", resetInactivityTimer);

    // Cleanup function to remove listeners when unmounting
    return () => {
      clearTimeout(inactivityTimer);
      window.removeEventListener("mousemove", resetInactivityTimer);
      window.removeEventListener("keydown", resetInactivityTimer);
      window.removeEventListener("scroll", resetInactivityTimer);
    };
  }, []);

  return null;
};
